import script from "./device.vue?vue&type=script&setup=true&lang=js"
export * from "./device.vue?vue&type=script&setup=true&lang=js"

import "./device.vue?vue&type=style&index=0&id=66a028ea&lang=scss&scoped=true"

import exportComponent from "D:\\job\\workCode\\数据可视化平台\\公园可视化平台\\admin-vue-data\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a028ea"]])

export default __exports__